var _defs, _g, _line, _g2, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2834.65 2834.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 160px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #58595b;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        stroke-width: 40px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-6 {\n        fill: #58595b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 2834.65,
    height: 2834.65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1417.32,2098.77c652.09,0,1180.71-680.19,1180.71-680.19,0,0-528.62-680.18-1180.71-680.18S236.61,1418.59,236.61,1418.59c0,0,528.62,680.19,1180.71,680.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1417.32,1995.98c318.88,0,577.39-258.51,577.39-577.39s-258.51-577.39-577.39-577.39-577.39,258.51-577.39,577.39,258.5,577.39,577.39,577.39"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1417.32,
    y1: 295.32,
    x2: 1417.32,
    y2: 772.46
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.14,
    y1: 926.16,
    x2: 421.73,
    y2: 1297.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2784.5,
    y1: 926.16,
    x2: 2412.92,
    y2: 1297.74
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 878.6,
    y1: 382.45,
    x2: 1088.4,
    y2: 844.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1956.05,
    y1: 382.45,
    x2: 1746.25,
    y2: 844.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 433.03,
    y1: 605.95,
    x2: 747.12,
    y2: 1023.43
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2401.62,
    y1: 605.95,
    x2: 2087.52,
    y2: 1023.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.1f69b964be17e1c7adecd6e367380e0f.svg";
export { ForwardRef as ReactComponent };